// extracted by mini-css-extract-plugin
export default {"wrapper":"FinalButton_wrapper__kXa5A"};